import PersonManagers from '@/screens/PersonManagers';

export default function PrivatePersonPersonIdEditManagersRoute() {
  return <PersonManagers />;
}
